import {isMobile} from "react-device-detect";

export function taobaoLink(keyword) {
    return isMobile ? 'https://ai.m.taobao.com/search.html?q=' + encodeURIComponent(keyword) + '&pid=mm_17192274_5524963_56988373' :
        'https://ai.taobao.com/search/index.htm?key=' + encodeURIComponent(keyword) + '&pid=mm_17192274_5524963_56988373'
}

